module.exports = __webpack_public_path__ + "img/anchor.cbac678f.png";